import classnames from 'classnames';
import arrowRightFromBase from '@ingka/ssr-icon/paths/arrow-right-from-base';
import { isCiamEnabled } from '../../../../utils/retailUnitsWithCiam';
import ListView, { ListViewItem } from '@ingka/list-view';
import { PREFIX } from '../../../Skapa/constants/constants';
import { useTranslation } from 'react-i18next';
import styles from './LogoutButton.module.scss';
import { useIcapsLogout } from '../../../../hooks/useIcapsLogout';
import { useMemo } from 'react';
import appMetaData from '@mvecom/common/utils/appMetadata';
import { toUrl, getAuthServiceUrl } from '../../../../utils/url';

export const LogoutButton = ({ onLoggedOut, standalone }: { onLoggedOut?: () => void; standalone?: boolean }) => {
  const { t } = useTranslation('profile');
  const icapsLogout = useIcapsLogout();

  const logoutHref = useMemo(() => {
    if (!appMetaData.language) {
      throw Error('No language found when logging out in mvagent');
    }

    if (!appMetaData.retailUnit) {
      throw Error('No retailUnit found when logging out in mvagent');
    }

    return toUrl(`${getAuthServiceUrl()}/logout`, {
      lang: appMetaData.language,
      retailUnit: appMetaData.retailUnit,
      referrer: window.location.href,
    });
  }, []);

  const component = isCiamEnabled ? (
    <ListViewItem
      className={classnames(styles.logoutButton, {
        [styles.standalone]: standalone,
      })}
      prefix={PREFIX}
      title={t('generic.logOut.linkText')}
      href={logoutHref}
      showDivider={false}
      controlIcon={null}
      leadingIcon={arrowRightFromBase}
      control="link"
    />
  ) : (
    <ListViewItem
      className={classnames(styles.logoutButton, {
        [styles.standalone]: standalone,
      })}
      prefix={PREFIX}
      title={t('generic.logOut.linkText')}
      onClick={() => icapsLogout.logout(onLoggedOut)}
      showDivider={false}
      controlIcon={null}
      leadingIcon={arrowRightFromBase}
      control="navigational"
    />
  );

  if (standalone) {
    return (
      <ListView id="standaloneLogoutButton" prefix={PREFIX} showDivider={false}>
        {component}
      </ListView>
    );
  }

  return component;
};
